"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteInitiativeTaskLink = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.deleteInitiativeTaskLink = (0, sonar_http_1.createDeleteEndpoint)(({ initiativeId }) => `/api/v2/initiatives/${initiativeId}/tasks/link`);
//# sourceMappingURL=deleteInitiativeTaskLink.js.map